import { CheckIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { cn } from '@/lib/utils';
import { type Period } from '@/modules/analytics/types';

interface Props {
  selected: boolean;
  onClick?: (item: Period) => void;
  item: Period;
  disabled?: boolean;
  variant?: 'chip' | 'check';
}

const DateFilterItem = ({ selected, onClick, item, disabled = false, variant = 'chip' }: Props) => {
  const { t } = useTranslation();

  return (
    <InfoTooltip
      delayDuration={300}
      content={disabled ? t('billing.date_filter_disabled') : ''}
      open={disabled ? undefined : false}
      showArrow
    >
      <button
        className={cn(
          'flex h-9 w-full items-center gap-2 self-stretch rounded-lg border border-transparent px-2.5 py-2 text-sm leading-5 font-medium',
          disabled && 'cursor-not-allowed text-foreground-muted',
          !disabled && 'text-foreground hover:bg-highlight-background',
          variant === 'chip' &&
            selected &&
            !disabled &&
            'border-informational bg-bg-info-soft text-informational',
          variant === 'check' && selected && !disabled && 'bg-highlight-background'
        )}
        disabled={disabled}
        aria-pressed={selected}
        onClick={() => onClick?.(item)}
      >
        <span className="whitespace-nowrap">{t(item.title_key)}</span>
        {variant === 'check' && selected ? (
          <CheckIcon size={16} className="ml-auto shrink-0 text-accent" />
        ) : null}
      </button>
    </InfoTooltip>
  );
};

export default DateFilterItem;
